<script lang="ts">
	import { page } from '$app/state';
	import type { Snippet } from 'svelte';
	import { themes } from './theme';

	interface Props {
		children?: Snippet;
		color?: number | null;
		size?: string;
	}
	let {
		children,
		color = 0,
		size = 'w-screen h-screen max-h-full max-w-full overflow-auto'
	}: Props = $props();

	let effectiveColor = $derived<number | null>(color);

	let viewport = $state<HTMLElement>();
	let previousRouteId: string | null | undefined = undefined;

	$effect(() => {
		const currentRouteId = page.route.id;
		if (previousRouteId !== undefined && previousRouteId !== currentRouteId) {
			if (viewport) viewport.scrollTop = 0;
		}
		previousRouteId = currentRouteId;
	});
</script>

<div
	bind:this={viewport}
	class="modern-background {size} transition-colors duration-1000 flex flex-col
	{effectiveColor !== null && themes[effectiveColor]
		? themes[effectiveColor].background + ' bg-linear-to-br'
		: ''}"
>
	{@render children?.()}
</div>
